import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { FiltersFormCertificate } from './types';

export const transformDataset = (values: FiltersFormCertificate): string => {
  const { orders, page, rowsPerPage, ...otherValues } = values;

  const identifier = [otherValues?.acronym || '', otherValues?.year, otherValues?.progressive]
    .filter((el) => el)
    .join('');

  const [tipoCertificato, codiceCertificato] =
    otherValues.certificateType?.split('-') || ''.split('');

  const transformedFilters: OperationObject = {
    fgDocErogatoDaSipo: { value: '0', operation: Operation.EQUALS }, // fixed
    idCertificato: { value: identifier, operation: Operation.EQUALS },
    tipoCertificato: { value: tipoCertificato || '', operation: Operation.EQUALS },
    codiceTipo: { value: codiceCertificato || '', operation: Operation.EQUALS },
    flagAnnullati: { value: otherValues.void || '', operation: Operation.EQUALS },
    tipoPagamento: { value: otherValues.payment || '' },
    codiceServizio: { value: otherValues.service === 'ALL' ? '' : otherValues.service || '' },
    codiceOperatore: { value: otherValues.operator === 'ALL' ? '' : otherValues.operator || '' },
    rilascioAl: {
      value: otherValues.dateTo ? otherValues.dateTo.toFormat('MM-dd-yyyy') : '',
      operation: Operation.EQUALS,
    },
    rilascioDal: {
      value: otherValues.dateFrom ? otherValues.dateFrom.toFormat('MM-dd-yyyy') : '',
      operation: Operation.EQUALS,
    },
    dataAnnullamentoDal: {
      value: otherValues.dateFromVoid ? otherValues.dateFromVoid.toFormat('MM-dd-yyyy') : '',
      operation: Operation.EQUALS,
    },
    dataAnnullamentoA: {
      value: otherValues.dateToVoid ? otherValues.dateToVoid.toFormat('MM-dd-yyyy') : '',
      operation: Operation.EQUALS,
    },
    codiceFiscale: {
      value: otherValues.fiscalCode || '',
      operation: Operation.EQUALS,
    },
    cognome: {
      value: otherValues.surname || '',
      operation: Operation.LIKE,
    },
    nome: {
      value: otherValues.name || '',
      operation: Operation.LIKE,
    },
  };

  const ordersToTransform = orders || {};

  //mancano -> annullato, data certificato, codice fiscale, importo
  const ordersMapped = {
    idCertificatoSort: ordersToTransform.serviceNumber,
    tipoCertificatoSort: ordersToTransform.type,
    tipoPagamentoSort: ordersToTransform.release,
    codiceOperatoreSort: ordersToTransform.operator,
    codiceServizioSort: ordersToTransform.serviceCode,
    //codiceStatoSort: ordersToTransform.progressive,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
    page,
    rowsPerPage,
  })}`;
};
